/** Import dependencies */
import React from 'react';
import LightboxDR from './lightbox-dr';
import LightboxCOH from './lightbox-coh';
import LightboxADV from './lightbox-adv';
import '../styles/lightbox.scss';

/**
 * Campaign vars:
 * coh  = Circle of Hope
 * dr = direct response
 * adv = advocacy
 */
interface IData {
     data: any;
}

/** This class only renders the campaign component, it is needed so that we do not alter other style or tsx files */
export default class LightboxWrapper extends React.Component<IData>{
     public render() {
          const { data } = this.props;
          switch (data.campaign) {
               case 'coh':
                    return (<LightboxCOH {...data} />);
               case 'dr':
                    return (<LightboxDR {...data} />);
               case 'adv':
                    return (<LightboxADV {...data} />);
               default:
                    return (<div>No lightbox campaign defined!</div>);
          }

     }
}